import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { DialogModule } from '@angular/cdk/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from 'projects/sharing/general/interceptors/auth.interceptor';
import { WithCredentialsInterceptor } from 'projects/sharing/general/interceptors/with-credentials.interceptor';
import { ErrorInterceptor } from 'projects/sharing/general/interceptors/error.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { provideNgxMask } from 'ngx-mask';
import { ClarityService } from 'projects/sharing/general/services/clarity.service';
import { provideNlToast } from '@nicelink/ui';
import { MenuActionHeaderInterceptor } from './ims/core/http/menu-action-header.interceptor';
import { PermissionContextService } from 'projects/sharing/general/services/permission-context.service';

export function initClarity(clarityService: ClarityService): () => void {
  return () => clarityService.init();
}

export function initPermissionContext(
  permissionContextService: PermissionContextService,
): () => void {
  return () => permissionContextService.restoreMenus();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    DialogModule,
    OverlayModule,
    RouterModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MenuActionHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initClarity,
      deps: [ClarityService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initPermissionContext,
      deps: [PermissionContextService],
      multi: true,
    },
    provideNgxMask(),
    ...provideNlToast(),
  ],
})
export class AppModule {}
